import { useEffect } from "react";
import Seo from "@/components/Seo";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Hero from "@/sections/Hero";
import Marquee from "@/sections/Marquee";
import ChiSono from "@/sections/ChiSono";
import ComeFunziona from "@/sections/ComeFunziona";
import Percorso from "@/sections/Percorso";
import Podio from "@/sections/Podio";
import NewsAgenda from "@/sections/NewsAgenda";
import Gallery from "@/sections/Gallery";
import Sponsor from "@/sections/Sponsor";
import Collaborazioni from "@/sections/Collaborazioni";
import OltreLoSport from "@/sections/OltreLoSport";
import Contatti from "@/sections/Contatti";

export default function Home() {
  // registra la posizione di scroll a ogni movimento (mai al mount: sovrascriverebbe
  // il valore prima che il ripristino del tasto "indietro" lo legga).
  // Il guard sul pathname evita di salvare lo 0 forzato dal clamp durante
  // il caricamento lazy della pagina Risultati (fallback basso = scroll azzerato).
  useEffect(() => {
    let ticking = false;
    const save = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        if (window.location.pathname === "/") {
          sessionStorage.setItem("gb-home-scroll", String(window.scrollY));
        }
        ticking = false;
      });
    };
    window.addEventListener("scroll", save, { passive: true });
    return () => window.removeEventListener("scroll", save);
  }, []);

  return (
    <div className="bg-[#090D14]">
      <Seo
        title="Giacomo Bertagnolli | Sciatore Paralimpico di Sci Alpino"
        description="Giacomo Bertagnolli, sciatore paralimpico italiano di sci alpino: 13 medaglie paralimpiche, titoli mondiali e Coppe del Mondo. Biografia, risultati e news."
        path="/"
      />
      <Navbar />
      <main id="contenuto">
        <Hero />
        <Marquee />
        <ChiSono />
        <ComeFunziona />
        <Percorso />
        <Podio />
        <NewsAgenda />
        <Gallery />
        <Sponsor />
        <OltreLoSport />
        <Collaborazioni />
        <Contatti />
      </main>
      <Footer />
    </div>
  );
}
